import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, withStyles } from "@material-ui/core";
import t from "../../../languages/pl";
import CancelAcceptForm from "../../Common/CancelAcceptForm";
import NewUserForm from "./NewUserForm";
import AssignCarsDialog from "../../Common/AssignCarsDialog";
import { isEmail, isQsafePrefix } from "../../../utils/helpers";
import ConfirmationDialog from '../../Common/ConfirmationDialog';
import { getLogin } from "../../../config/sessionData";

const useStyles = theme => ({
  button: {
    margin: theme.spacing(1),
    marginTop: 0
  },
  title: {
    paddingBottom: theme.spacing(1)
  }
});

const validateUserData = data => {
  if (!isEmail(data.email))
    return false;
  if (!isQsafePrefix(getLogin(), data.username))
    return false;
  if (data.expiration === "")
    return false;
  if (data.name.length < 1)
    return false;
  return true;
};

const AddUser = props => {
  const { classes, onSubmit } = props;
  const [open, setOpen] = useState(false);
  const [assignCarsOpen, setAssignCarsOpen] = useState(false);
  const [userData, setUserData] = useState(null);
  const [carIds, setCarIds] = useState([]);
  const [noExpirationConf, setNoExpirationConf] = useState(false);
  const [userTyp, setUserTyp] = useState("podrzedny");
  const ref = useRef();

  const handleSubmit = (state) => {
    if (validateUserData(state)) {
      setUserData(state);
      if (state.expiration === 0)
        return setNoExpirationConf(true);
      finalSubmit(state);
    }
    //TODO some kind of action when input validation failed
  };

  const handleSubmitWithNoExpirationPass = () => {
    finalSubmit();
  };

  const finalSubmit = (state) => {
    if (!state)
      onSubmit && onSubmit({ ...userData, carIds: carIds });
    else onSubmit && onSubmit({ ...state, carIds: carIds });
    setOpen(false);
  };

  const handleAssignCarsSubmit = (carIds) => {
    setCarIds(carIds);
    setAssignCarsOpen(false);
  };

  const handleOnTypeChange = (type) => {
    setUserTyp(type);
  };

  return (
    <React.Fragment>
      <Button
        variant="contained"
        color="primary"
        className={classes.button}
        onClick={() => setOpen(true)}
      >
        {t.addUser}
      </Button>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle className={classes.title}>
          {t.addUser}
        </DialogTitle>
        <DialogContent>
          <NewUserForm
            ref={ref}
            onBlur={handleSubmit}
            onTypeChange={handleOnTypeChange}
          />
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            disabled={userTyp==="podadmin"}
            onClick={() => setAssignCarsOpen(true)}
          >
            {t.assignCars}
          </Button>
          <CancelAcceptForm
            onCancel={() => setOpen(false)}
            onSubmit={() => ref.current.dispatchEvent(new Event("submit"))}
          />
        </DialogActions>
      </Dialog>
      {
        assignCarsOpen
        &&
        <AssignCarsDialog
          open={assignCarsOpen}
          onClose={() => setAssignCarsOpen(false)}
          onSubmit={handleAssignCarsSubmit}
          title={t.forUser}
        />
      }
      <ConfirmationDialog
        open={noExpirationConf}
        onClose={() => setNoExpirationConf(false)}
        onSubmit={handleSubmitWithNoExpirationPass}
        action={t.noPasswordExpirationConfirmationMessage}
      />
    </React.Fragment>
  );
};

AddUser.propTypes = {
  classes: PropTypes.object,
  onSubmit: PropTypes.func
};

export default withStyles(useStyles)(AddUser);
